import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import template from './index.vdt';
import { Tag } from '../tag/base';
export var Tip = /*#__PURE__*/function (_Tag) {
  _inheritsLoose(Tip, _Tag);
  function Tip() {
    return _Tag.apply(this, arguments) || this;
  }
  return Tip;
}(Tag);
Tip.template = template;